<template>
  <el-main>
    <el-row type="flex">
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="getList">{{$t('default.refresh')}}<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button style="margin-right: 10px;" width="100px;" type="primary" @click="dialogFormVisible = true">{{$t('default.createUser')}}</el-button>
      <el-select style="margin-right: 10px;" @change="getList" v-model="organizationId">
        <el-option
          key="all"
          :label="$t('default.allOrganization')"
          value="all">{{$t('default.allOrganization')}}
        </el-option>
        <el-option
          v-for="or in organizations"
          :key="or._id"
          :value="or._id"
          :label="or.name">
        </el-option>
      </el-select>
    </el-row>
    <el-table style="margin-top: 10px" border v-loading="loading" :data="users">
      <el-table-column prop="_id" label="Account ID">
      </el-table-column>
      <el-table-column prop="username" :label="$t('default.username')">
      </el-table-column>
      <el-table-column prop="remark" :label="$t('default.remark')">
      </el-table-column>
      <el-table-column prop="type" :label="$t('default.userType')" width="200">
        <template slot-scope="scope">
          {{scope.row.organizationId && typeMap[scope.row.type]}}
        </template>
      </el-table-column>
      <el-table-column prop="organizationId" :label="$t('default.bindOrganization')">
        <template slot-scope="scope">
          {{scope.row.organizationId && organizationsMap[scope.row.organizationId]}}
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" :label="$t('default.createdAt')">
        <template slot-scope="scope">
          {{getDate(scope.row.createdAt)}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('default.actions')"
        width="100">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="text" size="small">{{$t('default.edit')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      layout="prev, pager, next, total"
      :total="total">
    </el-pagination>
    <UserDialog ref="user_dialog" :dialogFormVisible.sync="dialogFormVisible" @refresh="getList"/>
  </el-main>
</template>

<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  .el-aside {
    color: #333;
  }
</style>

<script>
// import oss from '../utils/oss'
import UserDialog from '../components/UserDialog'
import moment from 'moment'
export default {
  components: { UserDialog },
  data () {
    return {
      loading: false,
      dialogFormVisible: false,
      mode: 'ai',
      list: [],
      users: [],
      pageSize: 10,
      organizations: [],
      typeMap: {
        normal: this.$t('default.normal'),
        organization_admin: this.$t('default.organization_admin')
      },
      organizationsMap: {},
      organizationId: 'all',
      total: 0,
      currentPage: 1
    }
  },
  mounted: async function () {
    await this.getAllOrganizations()
    this.getList()
    console.log(this.$route)
  },
  methods: {
    getDate (createdAt) {
      return moment(createdAt).format('YYYY-MM-DD HH:mm')
    },
    async getAllOrganizations () {
      let result = {}
      try {
        result = await this.$store.dispatch('getAllOrganizations')
      } catch (err) {
        console.log(err)
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.organizations = data.organizations
        this.organizations.map((account) => {
          this.organizationsMap[account._id] = account.name
        })
      }
    },
    edit (row) {
      this.$refs.user_dialog.edit(row)
      this.dialogFormVisible = true
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    async getList () {
      this.loading = true
      let result = {}
      try {
        result = await this.$store.dispatch('getUsers', {
          pageSize: this.pageSize,
          organizationId: this.organizationId,
          currentPage: this.currentPage
        })
      } catch (err) {
        console.log(err)
        this.$notify({
          title: '请求失败',
          type: 'error'
        })
        this.loading = false
        return false
      }
      const { code, data } = result.data
      if (code === 0) {
        this.users = data.users
        this.total = data.total
      }
      this.loading = false
    }
  }
}
</script>
